import { render, staticRenderFns } from "./contentShare.vue?vue&type=template&id=6f3b88a8&scoped=true&"
import script from "./contentShare.vue?vue&type=script&lang=js&"
export * from "./contentShare.vue?vue&type=script&lang=js&"
import style0 from "./contentShare.vue?vue&type=style&index=0&id=6f3b88a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b88a8",
  null
  
)

export default component.exports